import { Component } from '@angular/core';
import { environment } from '@/environments/environment';

@Component({
  selector: 'app-environment-banner',
  standalone: true,
  template: `
    @if (!isProduction) {
      <div class="env-banner">
        <span>DEV</span>
      </div>
    }
  `,
  styles: `
    .env-banner {
      position: fixed;
      top: 12px;
      right: -35px;
      z-index: 9999;
      background: #ff6b35;
      color: white;
      padding: 4px 40px;
      font-size: 11px;
      font-weight: 700;
      font-family: 'Oswald', sans-serif;
      text-transform: uppercase;
      letter-spacing: 1px;
      transform: rotate(45deg);
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
      pointer-events: none;
    }
  `,
})
export class EnvironmentBannerComponent {
  readonly isProduction = environment.production;
}
